import { AlgoliaProductHit } from '../types';

export const paginateHits = (hits: Array<AlgoliaProductHit>, hitsPerPage: number) => {
  if (!Array.isArray(hits) || !Number.isInteger(hitsPerPage)) {
    console.error('Invalid type argument type for paginateHits');
    return [];
  }

  return hits
    .map((_, index) => {
      return index % hitsPerPage === 0 ? hits.slice(index, index + hitsPerPage) : null;
    })
    .filter(Boolean) as Array<Array<AlgoliaProductHit>>;
};
